var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"number","name":"place","min":"1","max":"20","value":"1"},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }